import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { UserInfo } from 'src/app/core/models/userInfo';
import { IPage, setupPageParams } from 'src/app/shared/utils/page';
import { onlyNumbers } from 'src/app/shared/utils/utils';

@Injectable()
export class UserProfileService {

  private hideNavbar = new Subject<any>();
  hideNavbar$ = this.hideNavbar.asObservable();

  constructor(private http: HttpClient) { }

  // get user type from server
  getUserRoles(): Observable<any> {
    return this.http.get('user-details/details');
  }

  hideOrShowNavbar(hideNavbar: boolean) {
    this.hideNavbar.next(hideNavbar);
  }

  // get user details with email
  getUsersInfoByEmail(userEmail): Observable<any> {
    return this.http.get(`user-info/email?search=${userEmail}`, { withCredentials: true });
  }
  getUsersInfoById(username: string): Observable<any> {
    return this.http.get(`user-info/qID?search=${username}`, { withCredentials: true });
  }
  getAllUsers(makeName, pageNumber, pageSize = 10, query?: string): Observable<IPage<UserInfo>> {
    query = query ?? ''
    const params = { params: { ...setupPageParams(pageNumber, pageSize), makeName, query }, withCredentials: true }
    return this.http.get<IPage<UserInfo>>(`user-info/external`, params);
  }

  saveNewUser(userInfo): Observable<any> {
    return this.http.post(`user-info/saveNewUserInfo`, userInfo, { withCredentials: true });
  }
  userLogin(userObj, brandType): Observable<any> {
    return this.http.post(`login/login?brandType=${brandType}`, userObj, { withCredentials: true });
  }
  forgotUsername(email, makeName): Observable<any> {
    return this.http.get(`user-info-public/forgotUsername?email=${email}&makeName=${makeName}`, { withCredentials: true });
  }
  // update user-info
  updateUserInfo(userObject): Observable<any> {
    return this.http.put(`user-info/admin/updateExistingUserInfo`, userObject, { withCredentials: true });
  }
  createNewUser(userObj): Observable<any> {
    const requestObj = {...userObj, phone: onlyNumbers(userObj.phone)}
    return this.http.post(`user-info-public/addNewUserInfo`, requestObj, { withCredentials: true });
  }
  /*===== manage password ======*/
  // change password
  changePassword(passwordObj): Observable<any> {
    return this.http.post('user-info/changePassword', passwordObj, { withCredentials: true });
  }
  // reset password
  sendResetLinkToUser(userId, make): Observable<any> {
    return this.http.get(`user-info-public/forgotPassword?userId=${userId}&makeName=${make}&host=${window.location.host}`, { withCredentials: true });
  }
  resetPassword(userObj): Observable<any> {
    return this.http.post(`user-info-public/resetPassword`, userObj, { withCredentials: true });
  }
  /* ==========Paypal===========*/
  verifyUserAgainstPaypal(userObj): Observable<any> {
    return this.http.post(`user-info-public/verifyUser`, userObj, { withCredentials: true });
  }
  /*===== manage notifications ======*/
  getAllUserEmails(userId): Observable<any> {
    return this.http.get(`user-info/qID/${userId}/allUserEmailNotification`, { withCredentials: true });
  }
  getAllUserNotificationPreferences(userId): Observable<any> {
    return this.http.get(`user-info/qID/${userId}/allUserManageNotification`, { withCredentials: true });
  }
  getEmailNotificationActivationStatus(userId): Observable<any> {
    return this.http.get(`user-info/qID/${userId}/findIsActiveUserEmailNotification`, { withCredentials: true });
  }
  addOrUpdateUserEmails(userId, emailInfo): Observable<any> {
    return this.http.post(`user-info/qID/${userId}/addNewOrUpdateUserEmailNotification`, emailInfo, { withCredentials: true });
  }
  addOrUpdateUserNotifications(userId, notificationsInfo): Observable<any> {
    return this.http.post(`user-info/qID/${userId}/addNewOrUpdateUserManageNotification`, notificationsInfo, { withCredentials: true });
  }
  // Get Billing Info
  getBillingInfo(username): Observable<any> {
    return this.http.get(`user-info/userBillingHistory?qID=${username}`, { withCredentials: true });
  }
  /*===== manage devices =====*/
  getAllUserDevicesInfo(userId): Observable<any> {
    return this.http.get(`user-info/qID/${userId}/allUserDeviceInfo`, { withCredentials: true });
  }
  /*===== saved bulletin manager==========*/
  getUserSavedBulletinGroupCategories(userId): Observable<any> {
    return this.http.get(`user-info/qID/${userId}/userSavedBulletinGroupCategory`, { withCredentials: true });
  }
  getUserSavedBulletins(userId): Observable<any> {
    return this.http.get(`user-info/qID/${userId}/userNotAssociatedToBulletinGroup`, { withCredentials: true });
  }
  associateBulletinToSavedGroups(userId, bulletinId): Observable<any> {
    return this.http.post(`user-info/qID/${userId}/addBulletinToSavedBulletinGroup/${bulletinId}`, '', { withCredentials: true });
  }
  addNewBulletinGroup(userId, groupName): Observable<any> {
    return this.http.post(`user-info/qID/${userId}/addNewUserBulletinGroup/${groupName}`, '', { withCredentials: true });
  }
  addNewBulletin(userId, bulletinId, bulletinType): Observable<any> {
    // tslint:disable-next-line:max-line-length
    return this.http.post(`user-info/qID/${userId}/addBulletinToSavedBulletinGroup/${bulletinType}/${bulletinId}`, '', { withCredentials: true });
  }
  findBulletinByNumber(bulletinNumber, bulletinType): Observable<any> {
    // tslint:disable-next-line:max-line-length
    return this.http.get(`common/findOneBulletinNumber/${bulletinNumber}?bulletinType=${bulletinType}`, { withCredentials: true });
  }
  getListOfSavedBulletinGroups(userId): Observable<any> {
    return this.http.get(`user-info/qID/${userId}/userBulletinGroupList`, { withCredentials: true });
  }
  renameSavedBulletinGroup(userId, bulletinGroupInfo): Observable<any> {
    return this.http.put(`user-info/qID/${userId}/renameExistingUserBulletinGroup`, bulletinGroupInfo, { withCredentials: true });
  }

  /* DELETE BEFORE
  /*
  deleteSavedBulletinGroup(userId, groupId): Observable<any> {
    return this.http.delete(`user-info/qID/${userId}/deleteExistingUserBulletinGroup/${groupId}`, {withCredentials : true});
  }*/
  deleteSavedBulletinGroup(userId, groupId): Observable<any> {
    return this.http.get(`user-info/qID/${userId}/deleteExistingUserBulletinGroup/${groupId}`, { withCredentials: true });
  }
  deleteSavedBulletin(userId, bulletinId): Observable<any> {
    return this.http.get(`user-info/qID/${userId}/deleteUserSavedBulletin/${bulletinId}`, { withCredentials: true });
  }
  associateBulletinToNewGroup(userId, bulletinId, groupName): Observable<any> {
    // tslint:disable-next-line:max-line-length
    return this.http.post(`user-info/qID/${userId}/associateBulletinId/${bulletinId}/toThisBulletinGroupName/${groupName}`, '', { withCredentials: true });
  }
  associateBulletinToExistingGroup(userId, bulletinId, groupId): Observable<any> {
    // tslint:disable-next-line:max-line-length
    return this.http.post(`user-info/qID/${userId}/associateBulletinId/${bulletinId}/toThisBulletinGroupId/${groupId}`, '', { withCredentials: true });
  }
  moveBulletinFromOneGroupToAnother(userId, bulletinId, toGroupId): Observable<any> {
    // tslint:disable-next-line:max-line-length
    return this.http.post(`user-info/qID/${userId}/moveThisBulletinId/${bulletinId}/toAnotherBulletinGroupId/${toGroupId}`, '', { withCredentials: true });
  }

  getCurrentOSSLinks(): Observable<any> {
    return this.http.get(`user-info/ossLinks`, { withCredentials: true });
  }

  getOSSLink(linkname): Observable<any> {
    return this.http.get(`user-info/ossLink?linkname=${linkname}`, { withCredentials: true });
  }
  getTisParamDetails(paramType): Observable<any> {
    const hostname = document.location.hostname
    return this.http.get(`tisParam/findTisParamDetailsByTypeAndName/paramType/${paramType}?paramName=${hostname}`);
  }
  getBMWDealerLocation(centerID, locationID): Observable<any> {
    return this.http.get(`getDealerLocation/getBMWData?centerId=${centerID}&locationId=${locationID}`)
  }
  getMINIDealerLocation(centerID, locationID): Observable<any> {
    return this.http.get(`getDealerLocation/getMINIData?centerId=${centerID}&locationId=${locationID}`)
  }
  getMOTORRADDealerLocation(centerID, locationID): Observable<any> {
    return this.http.get(`getDealerLocation/getMOTORRADData?centerId=${centerID}&locationId=${locationID}`)
  }

}
